// extracted by mini-css-extract-plugin
export default {"container":"DotBillbackTypeFilter_container__c+Zv1","label":"DotBillbackTypeFilter_label__INDTn","filter":"DotBillbackTypeFilter_filter__w3cre"};